import axios from 'axios'

export default {
    getCodes(id, categoryId) {
        return axios.get(`/api/resolutioncodes/lookup/${id}`,
            {
                params: {
                    categoryId: categoryId,
                    details: true
                }
            });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/repaircodeselector/api.js